"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var classes_1 = require("./classes");

function variable(name) {
  return new classes_1.Variable(name);
}

exports.variable = variable;

function functionCall(functionName) {
  var fields = functionName.split(".");

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return new classes_1.FunctionCall(fields, args);
}

exports.functionCall = functionCall;

function lambda(names, expression) {
  return new classes_1.LambdaFunction(expression, names);
}

exports.lambda = lambda;

function fields(expr) {
  for (var _len2 = arguments.length, fields = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    fields[_key2 - 1] = arguments[_key2];
  }

  return new classes_1.FieldAccess(expr, fields);
}

exports.fields = fields;

function add(lhs, rhs) {
  return new classes_1.Operator("+", lhs, rhs);
}

exports.add = add;

function sub(lhs, rhs) {
  return new classes_1.Operator("-", lhs, rhs);
}

exports.sub = sub;

function mul(lhs, rhs) {
  return new classes_1.Operator("*", lhs, rhs);
}

exports.mul = mul;

function div(lhs, rhs) {
  return new classes_1.Operator("/", lhs, rhs);
}

exports.div = div;

function number(v) {
  return new classes_1.NumberValue(v);
}

exports.number = number;

function string(v) {
  return new classes_1.StringValue(v);
}

exports.string = string;

function boolean(v) {
  return new classes_1.BooleanValue(v);
}

exports.boolean = boolean;

function date(v) {
  return new classes_1.DateValue(v);
}

exports.date = date;
exports.aggregationFunctions = [{
  name: "avg",
  displayName: "Average",
  inputTypes: ["number"]
}, {
  name: "median",
  displayName: "Median",
  inputTypes: ["number"]
}, {
  name: "sum",
  displayName: "Sum",
  inputTypes: ["number"]
}, {
  name: "min",
  displayName: "Min",
  inputTypes: ["number"]
}, {
  name: "max",
  displayName: "Max",
  inputTypes: ["number"]
}, {
  name: "stdev",
  displayName: "Standard Deviation",
  inputTypes: ["number"]
}, {
  name: "variance",
  displayName: "Variance",
  inputTypes: ["number"]
}, {
  name: "first",
  displayName: "First"
}, {
  name: "last",
  displayName: "Last"
}, {
  name: "count",
  displayName: "Count"
}];

function getCompatibleAggregationFunctions(inputType) {
  return exports.aggregationFunctions.filter(function (x) {
    return x.inputTypes == null || x.inputTypes.indexOf(inputType) >= 0;
  });
}

exports.getCompatibleAggregationFunctions = getCompatibleAggregationFunctions;

function getDefaultAggregationFunction(inputType) {
  if (inputType == "number" || inputType == "date") {
    return "avg";
  } else {
    return "first";
  }
}

exports.getDefaultAggregationFunction = getDefaultAggregationFunction;

var ExpressionCache =
/*#__PURE__*/
function () {
  function ExpressionCache() {
    _classCallCheck(this, ExpressionCache);

    this.items = new Map();
    this.textItems = new Map();
  }

  _createClass(ExpressionCache, [{
    key: "clear",
    value: function clear() {
      this.items.clear();
      this.textItems.clear();
    }
  }, {
    key: "parse",
    value: function parse(expr) {
      if (this.items.has(expr)) {
        return this.items.get(expr);
      } else {
        var result = classes_1.Expression.Parse(expr);
        this.items.set(expr, result);
        return result;
      }
    }
  }, {
    key: "parseTextExpression",
    value: function parseTextExpression(expr) {
      if (this.textItems.has(expr)) {
        return this.textItems.get(expr);
      } else {
        var result = classes_1.TextExpression.Parse(expr);
        this.textItems.set(expr, result);
        return result;
      }
    }
  }]);

  return ExpressionCache;
}();

exports.ExpressionCache = ExpressionCache;
/**
 * Verify user input expression
 * @param inputString The expression from user input
 * @param options Verification options
 */

function verifyUserExpression(inputString, options) {
  var expr; // Try parse the expression

  try {
    if (options.textExpression) {
      expr = classes_1.TextExpression.Parse(inputString);
    } else {
      expr = classes_1.Expression.Parse(inputString);
    }
  } catch (error) {
    return {
      pass: false,
      error: "Parse Error: " + error.message
    };
  }

  if (options.data) {
    if (options.expectedTypes) {
      var expectedTypes = new Set(options.expectedTypes);

      try {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = options.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ctx = _step.value;
            var value = expr.getValue(ctx);
            var valueType = typeof value;

            if (value == null || valueType == "undefined") {
              valueType = "null";
            }

            if (!expectedTypes.has(valueType)) {
              return {
                pass: false,
                error: "Type Error: unexpected ".concat(valueType, " returned")
              };
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } catch (error) {
        return {
          pass: false,
          error: "Evaluate Error: " + error.message
        };
      }
    } else {
      try {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = options.data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _ctx = _step2.value;
            expr.getValue(_ctx);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } catch (error) {
        return {
          pass: false,
          error: "Evaluate Error: " + error.message
        };
      }
    }
  }

  return {
    pass: true,
    formatted: expr.toString()
  };
}

exports.verifyUserExpression = verifyUserExpression;